import React from "react";
import { useTranslation } from "react-i18next";

export default function MissionStatement() {
  const { t } = useTranslation();

  return (
    <div className="flex justify-center items-center min-h-screen px-6">
      <div className="max-w-3xl p-8 rounded-2xl shadow-2xl border-4 border-yellow-500 bg-gradient-to-br from-yellow-400 to-yellow-600 text-black transform scale-105 hover:scale-110 transition-all duration-300 ease-in-out">
        <h1 className="text-4xl font-extrabold text-center text-black mb-4 font-playfair italic">
          {t("mission.title")}
        </h1>
        <p className="text-lg leading-relaxed font-semibold font-lora italic">
          {t("mission.intro1", {
            brand: <span className="text-yellow-900 font-bold">237Mechanic.com</span>,
          })}
        </p>
        <p className="mt-4 text-lg leading-relaxed font-semibold font-lora italic">
          {t("mission.intro2")}
        </p>
        <p className="mt-4 text-lg leading-relaxed font-semibold font-lora italic">
          {t("mission.intro3", {
            brand: <span className="text-yellow-900 font-bold">237Mechanic</span>,
          })}
        </p>
      </div>
    </div>
  );
}
